@for (viewModel of tableViewModels; track viewModel.table.id) {
    <app-floor-table
        [tableViewModel]="viewModel"
        [xScale]="xScale"
        [yScale]="yScale"
        [allTables]="tableViewModels"
        [venue]="venue"
        [activeEdges]="getActiveEdgesForTable(viewModel)"
        [isDragging]="draggedTable === viewModel"
        [ngClass]="hasMovedTableDuringDrag ? 'pointer-events-none' : ''"
        (bookingHover)="onBookingHover($event)"
    >
    </app-floor-table>
}
